"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextInput = void 0;
var _formsModule = _interopRequireDefault(require("@albelli/arc-3/lib/forms.module.css"));
var _loaderModule = _interopRequireDefault(require("@albelli/arc-3/lib/loader.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const TextInputNote = _ref => {
  let {
    loading,
    success,
    alert,
    error,
    small
  } = _ref;
  const className = error ? _formsModule.default["error"] : success ? _formsModule.default["success"] : alert ? _formsModule.default["alert"] : loading ? _formsModule.default["loading"] : "";
  const loadingContent = loading ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(_loaderModule.default["arc3-loader"], _loaderModule.default["arc3-loader--extra-small"], "arc3-padding-right")
  }), loading) : null;
  const noteContent = error || success || alert || loadingContent || " ";
  return /*#__PURE__*/_react.default.createElement("small", {
    className: (0, _classnames.default)(_formsModule.default["arc3-form-message"], "arc3-no-margin")
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      whiteSpace: "pre"
    },
    className: className
  }, noteContent));
};
const TextInput = exports.TextInput = /*#__PURE__*/_react.default.forwardRef((_ref2, ref) => {
  let {
    id,
    value,
    placeholder = "",
    label,
    isRequired,
    onChange,
    error,
    loading,
    success,
    alert,
    inlineButton,
    className,
    autoComplete,
    multiline,
    childOfForm = false,
    small,
    ...props
  } = _ref2;
  const formClasses = (0, _classnames.default)(className, {
    [_formsModule.default["arc3-form"]]: !childOfForm,
    "arc3-full-width": childOfForm,
    [_formsModule.default["arc3-form--small"]]: !childOfForm && small
  });
  const wrapperClasses = (0, _classnames.default)(_formsModule.default["arc3-form__input-wrapper"], "arc3-full-width", {
    [_formsModule.default["loading"]]: !!loading,
    [_formsModule.default["success"]]: !!success,
    [_formsModule.default["alert"]]: !!alert,
    [_formsModule.default["error"]]: !!error
  });
  let buttonInst;
  if (inlineButton) {
    buttonInst = /*#__PURE__*/_react.default.cloneElement(inlineButton, {
      className: _formsModule.default["arc3-form__inline-btn"]
    });
  }
  const input = /*#__PURE__*/_react.default.createElement("input", _extends({
    id: id,
    ref: ref,
    type: "text",
    placeholder: placeholder,
    "aria-required": !!isRequired,
    autoCapitalize: "off",
    autoCorrect: "off",
    autoComplete: autoComplete,
    spellCheck: "false",
    onChange: onChange,
    value: value,
    className: "arc3-no-margin"
  }, props));
  const textarea = /*#__PURE__*/_react.default.createElement("textarea", _extends({
    id: id,
    ref: ref,
    placeholder: placeholder,
    "aria-required": !!isRequired,
    autoCapitalize: "off",
    autoCorrect: "off",
    autoComplete: autoComplete,
    spellCheck: "false",
    onChange: onChange,
    value: value,
    wrap: "break",
    className: "arc3-no-margin"
  }, props));
  const cypressTag = loading ? "InputLoading" : success ? "InputSuccess" : alert ? "InputAlert" : error ? "InputError" : null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: formClasses
  }, !!label && /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: _formsModule.default["arc3-form-label"]
  }, label, isRequired ? " *" : null), /*#__PURE__*/_react.default.createElement("div", {
    className: wrapperClasses,
    "data-cy": cypressTag
  }, multiline ? textarea : input, buttonInst, /*#__PURE__*/_react.default.createElement(TextInputNote, {
    loading: loading,
    error: error,
    alert: alert,
    success: success
  })));
});
TextInput.propTypes = {
  /** Optional element id */
  id: _propTypes.default.string,
  /** Optional custom CSS classes */
  className: _propTypes.default.string,
  /** Set the value of the input */
  value: _propTypes.default.any,
  /** Set the placeholder text */
  placeholder: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  /** Label text for the input */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  /** Mark the input as *required* */
  isRequired: _propTypes.default.bool,
  /** makes the inputs the same height as small buttons */
  small: _propTypes.default.bool,
  /** Callback for onChange */
  onChange: _propTypes.default.func,
  /** Error text, sets state to *error* */
  error: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  /** Loading text, sets state to *loading* */
  loading: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  /** Success text, sets state to *success* */
  success: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  /** Alert text, sets state to *alert* */
  alert: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  /** A Button can be provided to add an inline button. See [Button](#button) example. */
  inlineButton: _propTypes.default.node,
  /** **Set Programmatically** if input is child of a form */
  childOfForm: _propTypes.default.bool
};